import { MultiSelect } from 'primereact/multiselect';

const BaseMultiSelect = (props) => {
    return <MultiSelect className={`${props.custom ? props.custom : ""} ${props.extra ? props.extra : ""}`} {...props} />;
}

export default BaseMultiSelect;